import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        match_id: "",
        match_time: "",
        match_duration: "",
        home_team_id: '',
        home_team_name: '',
        away_team_id: '',
        away_team_name: ''
      },
      tournament_id: '',
      unassignedList: [],
      homeTeamList: [],
      awayTeamList: [],
      rules: {
        match_time: [{
          required: true,
          message: "请输入加时赛",
          trigger: "blur"
        }],
        half_time: [{
          required: true,
          message: "请输入中场休息时间",
          trigger: "blur"
        }],
        match_duration: [{
          required: true,
          message: "请输入比赛时长",
          trigger: "blur"
        }],
        home_team_name: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        away_team_name: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.tournament_id = sessionStorage.getItem('coachId');

                if (data) {
                  _this.copyPrimitive();

                  _this.formData.match_id = data.id;
                  _this.formData.match_time = data.match_time;
                  _this.formData.match_duration = data.match_duration;
                  _this.formData.home_team_id = data.home_team_id;
                  _this.formData.home_team_name = data.home_team_name;
                  _this.formData.away_team_id = data.away_team_id;
                  _this.formData.away_team_name = data.away_team_name;

                  _this.copyData();

                  _this.getUnassignedTeamsInRoundFn(data);
                }

                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getHomeName: function getHomeName(data) {
      var data1 = this.homeTeamList.find(function (item) {
        return item.name == data;
      });
      this.formData.home_team_id = data1 ? data1["id"] : null;
    },
    getAwayName: function getAwayName(data) {
      var data1 = this.awayTeamList.find(function (item) {
        return item.name == data;
      });
      this.formData.away_team_id = data1 ? data1["id"] : null;
    },
    getUnassignedTeamsInRoundFn: function getUnassignedTeamsInRoundFn(data) {
      var _this2 = this;

      this.$api.getUnassignedTeamsInRound({
        tournament_id: this.tournament_id,
        round_name: data.round_name,
        match_id: data.id
      }).then(function (res) {
        if (res.code == 200) {
          var defaultList2 = [{
            id: null,
            name: '轮空'
          }, {
            id: null,
            name: '待定'
          }];
          var defaultList1 = [{
            id: null,
            name: '待定'
          }];
          _this2.homeTeamList = res.data.unassigned_teams.concat(defaultList1) || defaultList1;
          _this2.awayTeamList = res.data.unassigned_teams.concat(defaultList2) || defaultList2;
        }
      });
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    // console.log("this.formData",this.formData)
                    // if(this.formData.home_team_id == this.formData.away_team_id){
                    //   this.$message.error('组队和客队的名称不能一样')
                    //   return
                    // }
                    var data = JSON.parse(JSON.stringify(_this3.formData));

                    _this3.$api.updateMatches(data).then(function (res) {
                      if (res.code == 200) {
                        _this3.$message.success('修改成功');

                        _this3.$emit('change');

                        _this3.dialogFormVisible = false;
                      } else {
                        _this3.$message.error(res.msg);
                      }
                    }).catch(function (err) {
                      _this3.$message.error(err.msg);
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};